import $ from 'jquery';
import _ from 'lodash';
import BasePropertyView from 'BasePropertyView.js';
import _template from 'properties/table/column-style-caption.ejs';
import { pickerCfg } from 'pickerCfg.js';
import util from 'util/Util.js';
import fontService from 'FontService';

// PF-5745
import undoService from 'UndoService';
import textConstants from 'TextConstants';

class StyleTextView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;
        this.colId = this.model.get('selectedRowId');
        this.factoryKey = this.model.get('gridData')[this.colId].attributes['factoryKey'];

        this.selectedColor = 'lightgrey';
        this.unselectedColor = 'transparent';

        this.events = {
            'change #textColorText, #mouseOverTextColorText, #textDownColorText' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'click #boldText, #italicText' : 'updateTextStyleAttributes',
            'change #textColor, #mouseOverTextColor, #textDownColor' : 'updateColorPicker',
            'change #fontFamily, #customFontFamily, #fontSize' : 'updateFontAttributes'
        };

        const gridData = this.model.get('gridData')[this.colId];

        if (!gridData.attributes['textWeight']) {
            gridData.attributes['textWeight'] = 'normal !important';
            gridData.attributes['boldSelection'] = this.unselectedColor;
        }

        if(!gridData.attributes['textStyle']) {
            gridData.attributes['textStyle'] = 'normal !important';
            gridData.attributes['italicSelection'] = this.unselectedColor;
        }

        if (gridData.attributes['textStyle'] === 'italic !important') {
            gridData.attributes['italicSelection'] = this.selectedColor;
        }

        if (gridData.attributes['textWeight'] === 'bold !important') {
            gridData.attributes['boldSelection'] = this.selectedColor;
        }

        let currentFont = gridData.attributes['fontFamily'];

        if (!gridData.attributes['customFontFamily']){
            gridData.attributes['customFontFamily'] = "";
            gridData.attributes['customFontFamilyDisabled'] = 'disabled';
        }

        if (fontService.isCustomFont(currentFont)) {//If is a custom font
            currentFont = currentFont === "__custom__" ? "" : currentFont;
            gridData.attributes['customFontFamily'] = currentFont;
            gridData.attributes['customFontFamilyDisabled'] = '';
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        const oldPropVal = this.model.get('gridData')[this.colId].attributes[propName];

        if (util.isValidColorcode(propVal)) {
            let color = this.resolveColor(propVal);

            $('#' + propName).val(color);
            // needs to set to the Column Name for this Column
            this.model.get('gridData')[this.colId].attributes[propName] = color;
            //this.model.trigger('change');
            this.render();
        } else {
            this.render();
        }

        // PF-5745
        undoService.add({
            undo: () =>{
                let oldColor = this.resolveColor(oldPropVal);

                $('#' + propName).val(oldColor);
                // needs to set to the Column Name for this Column
                this.model.get('gridData')[this.colId].attributes[propName] = oldColor;
                this.render();
            },
            redo:() => {
                let color = this.resolveColor(propVal);

                $('#' + propName).val(color);
                // needs to set to the Column Name for this Column
                this.model.get('gridData')[this.colId].attributes[propName] = color;
                this.render();
            }
        },textConstants.UNDO_PROP_CHANGE);
    }

    updateTextStyleAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;

        var weight = this.model.get('gridData')[this.colId].attributes['textWeight'];
        var style = this.model.get('gridData')[this.colId].attributes['textStyle'];

        if(propName === 'textWeight') {
            if(weight.indexOf('bold') > -1) {
                this.model.get('gridData')[this.colId].attributes['boldSelection'] = this.unselectedColor;
                weight = 'normal !important';
            } else {
                this.model.get('gridData')[this.colId].attributes['boldSelection'] = this.selectedColor;
                weight = 'bold !important';
            }
        } else if(propName === 'textStyle') {
            if(style.indexOf('italic') > -1) {
                this.model.get('gridData')[this.colId].attributes['italicSelection'] = this.unselectedColor;
                style = 'normal !important';
            } else {
                this.model.get('gridData')[this.colId].attributes['italicSelection'] = this.selectedColor;
                style = 'italic !important';
            }
        }

        this.model.get('gridData')[this.colId].attributes['textWeight'] = weight;
        this.model.get('gridData')[this.colId].attributes['textStyle'] = style;
        this.render();
        

        // PF-5745
        undoService.add({
            undo: () =>{
                if(propName === 'textWeight') {
                    if(weight.indexOf('bold') > -1) {
                        this.model.get('gridData')[this.colId].attributes['boldSelection'] = this.unselectedColor;
                        weight = 'normal !important';
                    } else {
                        this.model.get('gridData')[this.colId].attributes['boldSelection'] = this.selectedColor;
                        weight = 'bold !important';
                    }
                } else if(propName === 'textStyle') {
                    if(style.indexOf('italic') > -1) {
                        this.model.get('gridData')[this.colId].attributes['italicSelection'] = this.unselectedColor;
                        style = 'normal !important';
                    } else {
                        this.model.get('gridData')[this.colId].attributes['italicSelection'] = this.selectedColor;
                        style = 'italic !important';
                    }
                }
        
                this.model.get('gridData')[this.colId].attributes['textWeight'] = weight;
                this.model.get('gridData')[this.colId].attributes['textStyle'] = style;
                this.render();
            },
            redo:() => {
                if(propName === 'textWeight') {
                    if(weight.indexOf('bold') > -1) {
                        this.model.get('gridData')[this.colId].attributes['boldSelection'] = this.unselectedColor;
                        weight = 'normal !important';
                    } else {
                        this.model.get('gridData')[this.colId].attributes['boldSelection'] = this.selectedColor;
                        weight = 'bold !important';
                    }
                } else if(propName === 'textStyle') {
                    if(style.indexOf('italic') > -1) {
                        this.model.get('gridData')[this.colId].attributes['italicSelection'] = this.unselectedColor;
                        style = 'normal !important';
                    } else {
                        this.model.get('gridData')[this.colId].attributes['italicSelection'] = this.selectedColor;
                        style = 'italic !important';
                    }
                }
        
                this.model.get('gridData')[this.colId].attributes['textWeight'] = weight;
                this.model.get('gridData')[this.colId].attributes['textStyle'] = style;
                this.render();
            }
        },textConstants.UNDO_PROP_CHANGE);
    }

    updateColorPicker(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.id;
        const propVal  = ev.currentTarget.value;
        const oldPropVal = this.model.get('gridData')[this.colId].attributes[propName];

        let color = this.resolveColor(propVal);
        var propTextName = propName + 'Text';
        $('#' + propTextName).val(color);
        // needs to set to the Column Name for this Column
        this.model.get('gridData')[this.colId].attributes[propName] = color;
        this.render();

        // PF-5745
        undoService.add({
            undo: () =>{
                let oldColor = this.resolveColor(oldPropVal);
                $('#' + propTextName).val(oldColor);
                // needs to set to the Column Name for this Column
                this.model.get('gridData')[this.colId].attributes[propName] = oldColor;
                this.render();
            },
            redo:() => {
                let color = this.resolveColor(propVal);

                $('#' + propTextName).val(color);
                // needs to set to the Column Name for this Column
                this.model.get('gridData')[this.colId].attributes[propName] = color;
                this.render();
            }
        },textConstants.UNDO_PROP_CHANGE);
    }


    // Delegate to super, so as to impose an override column model parameter -- we are a column view
    updateFontAttributes(ev) {

        let
            propName = ev.currentTarget.name,
            propVal = ev.currentTarget.value,
            currentEvent = ev,
            oldPropVal;

        switch (propName) {
            case "customFontFamily": 
            case "fontFamily": {
                oldPropVal = this.model.get('gridData')[this.colId].attributes.fontFamily;             
                break;
            }
            case "fontSize": {
                oldPropVal = this.model.get('gridData')[this.colId].attributes.fontSize;
                break;
            } 
           
        }       

        if(propName === "customFontFamily" || propName === "fontFamily"){
            const gridData = this.model.get('gridData')[this.colId];

            if (fontService.isCustomFont(propVal)) {//If is a custom font
                propVal = propVal === "__custom__" ? "" : propVal;
                gridData.attributes['customFontFamily'] = propVal;
                gridData.attributes['customFontFamilyDisabled'] = '';
            }
            else{
                gridData.attributes['customFontFamily'] = '';
                gridData.attributes['customFontFamilyDisabled'] = 'disabled';
            }
        }       

        super.updateAttributes(ev, this.model.get('gridData')[this.colId]);
        this.render();
    
        // PF-5745
        undoService.add({
            undo: () =>{
                if(propName === "customFontFamily" || propName === "fontFamily"){
                    const gridData = this.model.get('gridData')[this.colId];
        
                    if (fontService.isCustomFont(oldPropVal)) {//If is a custom font
                        oldPropVal = oldPropVal === "__custom__" ? "" : oldPropVal;
                        gridData.attributes['customFontFamily'] = oldPropVal;
                        gridData.attributes['customFontFamilyDisabled'] = '';
                    }
                    else{
                        gridData.attributes['customFontFamily'] = '';
                        gridData.attributes['customFontFamilyDisabled'] = 'disabled';
                    }
                }   
                currentEvent.currentTarget.value = oldPropVal;
                super.updateAttributes(currentEvent, this.model.get('gridData')[this.colId]);
                this.render();
            },
            redo:() => {

                if(propName === "customFontFamily" || propName === "fontFamily"){
                    const gridData = this.model.get('gridData')[this.colId];
        
                    if (fontService.isCustomFont(propVal)) {//If is a custom font
                        propVal = propVal === "__custom__" ? "" : propVal;
                        gridData.attributes['customFontFamily'] = propVal;
                        gridData.attributes['customFontFamilyDisabled'] = '';
                    }
                    else{
                        gridData.attributes['customFontFamily'] = '';
                        gridData.attributes['customFontFamilyDisabled'] = 'disabled';
                    }
                }   

                currentEvent.currentTarget.value = propVal;
                super.updateAttributes(currentEvent, this.model.get('gridData')[this.colId]);
                this.render();
            }
        },textConstants.UNDO_PROP_CHANGE);
    }

    render() {
        super.render();
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        const self = this;

        const fonts = fontService.loadFontsDropDown(true);
        $("#fontFamily").append(fonts);

        //Set Dropdowns
        if (this.model.get('gridData')[this.colId].attributes['fontFamily']) {
            let fontFamily = this.model.get('gridData')[this.colId].attributes['fontFamily'];
            const customFont = fontService.isCustomFont(fontFamily);
            fontFamily = !customFont ? fontFamily : "__custom__";

            $('#fontFamily')
                .find(`option[value="${fontFamily}"]`)
                .attr(`selected`, true);
        }

        if (this.model.get('gridData')[this.colId].attributes['fontSize']) {
            const ddValue = this.model.get('gridData')[this.colId].attributes['fontSize'];
            const ddl = $('#fontSize');
            ddl.val(ddValue);
        }

        this.delegateEvents();
        return this;
    }

}

export default StyleTextView;
